goog.provide("shadow.js.shim.module$$xyflow$react$default");
shadow.js.shim.module$$xyflow$react$default = shadow.js.require(2285, {}).default;
